import { SignzyInterface } from "../../domain/interface/SignzyRepository";

export class SignzyService {
  constructor(private signzyInterface: SignzyInterface) {}

  async submitConsent(consent: string): Promise<string> {
    if (!consent) throw new Error("Consent value is required");
    return this.signzyInterface.submitConsent(consent);
  }
}